module.exports = __webpack_public_path__ + "img/photo.b5d2fb35.svg";